import React from 'react';
import styled from 'styled-components';
import { assets } from '../../assets';
import { MattRow } from '../../components/containers/containers';
import { formatDateTime } from '../../helpers/date-formatters';
import { Notification } from '../../logic/graphql/types/types';
import { getDirectionIcon, getDirectionText } from '../../components/utils/direction-utils';
import { FormattedMessage, useIntl } from 'react-intl';

const NotificationCardWrapper = styled(MattRow).attrs(() => ({}))<{
  unread: boolean;
  mobileHeight: number;
}>`
  border: ${(props) => (props.unread ? '1px solid #ffffff' : '0px solid #ffffff')};
  margin-bottom: 10px;
  padding: 10px 15px;
  cursor: ${(props) => (props.unread ? 'pointer' : 'auto')};
  height: ${(props) => props.mobileHeight || 84}px;
  width: calc(100% - 8px);
  overflow: hidden;
  &:last-of-type {
    margin-bottom: 0px;
  }
  @media (min-width: 768px) {
    height: 104px;
  }
`;

const ClockIcon = styled.img`
  width: 15px;
  height: 15px;
  margin-right: 4px;
`;

const DirectionIcon = styled.img`
  width: 28px;
  height: 28px;
  margin-left: 7px;
`;

const NewLabel = styled.span`
  background-color: var(--success-color);
  border-radius: 2px;
  padding: 1.5px 4px;
  margin-right: 10px;
`;

const TextWrapper = styled.div`
  width: 100%;
  height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (min-width: 768px) {
    height: 54px;
  }
`;

const Text = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 11;
  overflow: hidden;
  @media (min-width: 768px) {
    -webkit-line-clamp: 3;
  }
`;

const NotificationCard = (props: {
  listItem: Notification;
  onClick?: (notification: Notification) => void;
  mobileHeight: number;
}): JSX.Element => {
  const intl = useIntl();
  const handleOnClick = (): void => {
    if (props.onClick) {
      props.onClick(props.listItem);
    }
  };

  return (
    <NotificationCardWrapper
      onClick={handleOnClick}
      unread={props.listItem.unread}
      mobileHeight={props.mobileHeight}
    >
      <div className="flex flex-col md:flex-row justify-between">
        <div className="flex-row items-center hidden md:flex">
          {props.listItem.unread && (
            <NewLabel className="text-10">
              <b>
                <FormattedMessage id={'notification.newBadge'} />
              </b>
            </NewLabel>
          )}
          <ClockIcon src={assets.icons.clock} />
          <span className="text-10 text-lightgray">{formatDateTime(props.listItem.time)}</span>
        </div>
        <div className="flex flex-row items-center self-end">
          <span className="text-10 text-gray">
            {intl.formatMessage({
              id: `notification.type.${getDirectionText(props.listItem.direction)}`,
            })}
          </span>
          <DirectionIcon src={getDirectionIcon(props.listItem.direction)} />
        </div>
      </div>
      <TextWrapper>
        <Text className="text-12">
          {intl.locale === 'en' && props.listItem.text_en !== ''
            ? props.listItem.text_en
            : props.listItem.text}
        </Text>
      </TextWrapper>
      <div className="flex flex-row justify-between md:hidden">
        {props.listItem.unread ? (
          <NewLabel className="text-10">
            <b>
              <FormattedMessage id={'notification.newBadge'} />
            </b>
          </NewLabel>
        ) : (
          <div />
        )}
        <div className="flex flex-row items-center">
          <ClockIcon src={assets.icons.clock} />
          <span className="text-10 text-lightgray">{formatDateTime(props.listItem.time)}</span>
        </div>
      </div>
    </NotificationCardWrapper>
  );
};

export default NotificationCard;
